/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditMentionsAuditMentionsMatchesListQueryResponse, AuditMentionsAuditMentionsMatchesListQueryParams } from "../models/AuditMentionsAuditMentionsMatchesList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditMentionsAuditMentionsMatchesList } from "../axios/auditMentionsAuditMentionsMatchesList";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditMentionsAuditMentionsMatchesListQueryKey = (params: AuditMentionsAuditMentionsMatchesListQueryParams) => ["api-v2", { url: '/audit-mentions/v1/matches' }, ...(params ? [params] : [])] as const

export type AuditMentionsAuditMentionsMatchesListQueryKey = ReturnType<typeof auditMentionsAuditMentionsMatchesListQueryKey>

export function auditMentionsAuditMentionsMatchesListQueryOptions(params: AuditMentionsAuditMentionsMatchesListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditMentionsAuditMentionsMatchesListQueryKey(params)
        return queryOptions<AuditMentionsAuditMentionsMatchesListQueryResponse, ResponseErrorConfig<Error>, AuditMentionsAuditMentionsMatchesListQueryResponse, typeof queryKey>({
         enabled: !!(params),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditMentionsAuditMentionsMatchesList(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns paginated mention matches using the mi-api CRUD list contract. Filterable fields: `datetime`, `name`, `type`, `author`, `confidence`.
 * @summary List mention matches
 * {@link /audit-mentions/v1/matches}
 */
export function useAuditMentionsAuditMentionsMatchesList<TData = AuditMentionsAuditMentionsMatchesListQueryResponse, TQueryData = AuditMentionsAuditMentionsMatchesListQueryResponse, TQueryKey extends QueryKey = AuditMentionsAuditMentionsMatchesListQueryKey>(params: AuditMentionsAuditMentionsMatchesListQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditMentionsAuditMentionsMatchesListQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditMentionsAuditMentionsMatchesListQueryKey(params)
         

         const query = useQuery({
          ...auditMentionsAuditMentionsMatchesListQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}